// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_XgN","cls2":"UserTaggingPingBodyStyles-cls2_ZRW UserTaggingPingBodyStyles-cls1_XgN"};